<template>
  <div class="about">
    <van-nav-bar
      :title="$t('my')+'（'+this.number.mobile+'）'"
      left-arrow
      @click-left="onClickLeft"
    />
    <ul>
      <li class="van-hairline--bottom" @click="Cancelaccount">
        <div>
          <van-icon name="replay" />
          {{$t('logout')}}
        </div>
        
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>

      <li class="van-hairline--bottom" @click="Cancelpassword">
        <div>
          <van-icon name="font-o" />
          {{$t('xgmm')}}
        </div>
        
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>

      <li class="van-hairline--bottom" @click="Visitorinvtion" >
        <div><van-icon name="share-o" size="" />
        {{$t('fkyq')}}</div>
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>

      <li class="van-hairline--bottom" @click="myhouscode" >
        <div><van-icon name="manager-o" size="" />
        {{$t('wdmk')}}</div>
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>
      
      <li class="van-hairline--bottom" @click="Deletepermissions" >
        <div><van-icon name="delete-o" size="" />
        {{$t('scqx')}}</div>
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>
      <div class="qrouds">
        <van-dialog v-model="show"   cancel-button-text="关闭"   :show-confirm-button='false'>
          <div  style="margin-bottom:15px" >
            <van-form ref="myform" >
               <van-field
              v-model="card"
              name="phone"
              :label="$t('kh')"
              :placeholder="$t('qtxkh')"
              :rules="[
                { required: true, message: this.$t('qtxkh') }
              ]"
              />
            </van-form>
            
          </div>

            <vue-qr 
              v-if="qrcodflag"
              :size="191"
              :margin="0"
              :auto-color="true"
              :dot-scale="1"
              :text="appSrc"
              
            />

            <div  :class="qrcodflag ? 'qurys van-hairline--top':'qurys' ">
              <div class="guanb" @click="handleConfirm2">{{$t('gb')}}</div>
              <div class="qurey" @click="handleConfirm">{{$t('qd')}}</div>
            </div> 




        </van-dialog>
      </div>

      <div class="qrouds">
        <van-dialog v-model="show2" :title="$t('wdmk')"  :cancel-button-text="$t('gb')"   :show-confirm-button='false'>
          <div  style="margin-bottom:15px" >
            <van-form ref="myform" >
               <van-field
              v-model="card_no"
              name="phone"
              type="number"
              :label="$t('kh')"
              :placeholder="$t('qtxkh')"
              
              />
            </van-form>
          </div>
          <div v-if="this.mycardnumber">
            <vue-qr 
              :size="191"
              :margin="0"
              :auto-color="true"
              :dot-scale="1"
              :text="appSrc"
            />
          </div>
            

            <div  class="qurys van-hairline--top">
              <div class="guanb" @click="myhouscodeConfirm2">{{$t('gb')}}</div>
              <div class="qurey" @click="myhouscodeConfirm">{{$t('qd')}}</div>
            </div> 
        </van-dialog>
      </div>

      <li class="van-hairline--bottom" @click="Authoritymon">
        <div>
        <van-icon name="setting-o" />
        {{$t('qxgl')}}
        </div> 
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>
       <div class="qroud">
         <van-dialog v-model="show1" :confirmButtonText="$t('qd')" :cancelButtonText="$t('qx')" show-cancel-button>
          <vue-qr 
          :size="191"
          :margin="0"
          :auto-color="true"
          :dot-scale="1"
          :text="appSrc"
          
        />
          </van-dialog>
       </div>
    </ul>


  </div>
</template>
<script>
import { Dialog } from 'vant';
import VueQr from 'vue-qr'
import CRC from "@/crc16xm/crc16array.js"
import AESHQT from "@/aeshqt/aes.js" 
import { Toast } from 'vant';
// import {base64ToString,CharToHex} from '@/utils/index'
// var flow_no = 0;
export default {
  components:{
    VueQr
  },
  data(){
    return{
      show:false,
      show1:false,
      show2:false,
      mycard:false,
      card_no:'',
      mycardnumber:'',
      // attendanceName:'',
      logoSrc: '',
      appSrc: '',
      listdata:[],
      card:'',
      qrcodflag:false,
      number:JSON.parse(window.localStorage.getItem('datauser')),
      clearTimeSet:''
    }
  },
  
  mounted(){
    // this.qrCodeCreate()
    this.getmyHouscard()
  },
  methods:{
    getmyHouscard(){
      let data={
        method:'co.wx.visit.card.get',
        user_id:this.number.user_id,
        platform:'pwa'
      }
      this.$serve(data).then(res=>{
        if(res.data.code==0){
          if(res.data.data){
            this.mycard = false
            this.mycardnumber = res.data.data
            this.card_no =res.data.data
          }else{
            this.mycard = true
          }
        }
      })
    },
    onClickLeft(){
      this.$router.go(-1);
    },
    // 访客邀请
    Visitorinvtion(){
      this.$router.push({ path: '/visitorint' })
    },
    // 我的房卡弹窗关闭
    myhouscodeConfirm2(){
      this.show2 = false
       clearInterval(this.clearTimeSet);
    },
    
    myhouscodeConfirm(){
      // console.log()
      if(this.mycardnumber != this.card_no){
        let data={
          method:'co.wx.visit.card.bind',
          user_id:this.number.user_id,
          platform:'pwa',
          card_no:this.card_no
        }
        if(this.card_no.length<8){
          Toast.fail(this.$t('qsr8wdkh'))
          return false
        }
        this.$serve(data).then(res=>{
          console.log(res.data)
          if(res.data.code==0){
            Toast.success(this.$t('bdcg'))
            this.show2 = false
            this.getmyHouscard()
          }else{
            Toast.fail(this.$t('bdsb'))
          }
        })
      }else{
        this.show2 = false
         clearInterval(this.clearTimeSet);
      }
      
    },
    // 修改密码
    Cancelpassword(){
      this.$router.push({ path: '/clpas' })
    },
    // 注销账号
    Cancelaccount(){
      Dialog.alert({
        message: this.$t('qdzxzhm'),
        showCancelButton:true,
        closeOnClickOverlay:true,
        cancelButtonText:this.$t('qx'),
        confirmButtonText:this.$t('qd')
      }).then(() => {
        window.localStorage.removeItem('datauser')
        this.$router.push({ path: '/login' })
      });
    },
    // 删除权限
    Deletepermissions(){
      this.show = !this.show
      this.qrcodflag= false
    },
    handleConfirm(){
      this.qrcodflag= true
      this.qrCodeCreate('X',this.card)
    },
    handleConfirm2(){
      this.card=""
      this.show = false
    },
    // 权限管理
    Authoritymon(){
      this.qrCodeCreate('Z','00000000')
      this.show1 = !this.show1
    },
     handeldow(){
      // this.qrCodeCreate()
          this.clearTimeSet=setInterval( () =>{
             this.qrCodeCreate('Y',this.mycardnumber)
          }, 300);
      },
    // 我的门卡二维码
    myhouscode(){
      this.handeldow()
      this.show2 = !this.show2
    },
    qrCodeCreate(ps,card){
      var mobile_number = this.number.mobile;
      console.log(`989`,mobile_number)
      
      mobile_number = this.getPhoneNineNumber(mobile_number);      
      //console.log("9位手机号"+mobile_number); 
      mobile_number = parseInt(mobile_number).toString(16).toUpperCase();
      mobile_number = this.checkHexZero(mobile_number);
      mobile_number = ('00000000'.substr(0, 8 - mobile_number.length))+mobile_number


      //  let base64encrypt = base64ToString(this.number.encrypt)


      // let encrypt = CharToHex(base64encrypt)


      // let mobile_number = encrypt.split(',').join('')



      //随机数(1000--2000)
      var random_number = Math.floor(Math.random() * 1000 + 1000);
      // random_number = 1500;
      random_number = parseInt(random_number).toString(16).toUpperCase();
      random_number = this.checkHexZero(random_number);

      var utc_number = new Date().getTime() / 1000;
      // utc_number = 1627625901;
      utc_number = parseInt(utc_number).toString(16).toUpperCase();
      utc_number = this.checkHexZero(utc_number);

      var crc_source = mobile_number + random_number + utc_number;

      var len = crc_source.length / 2;
      var arr = new Uint8Array(len);
      var i;
      for(i=0;i<len;i++){
        arr[i] = parseInt(crc_source.substr(i*2, 2), 16);
      }
       var crc_result = CRC.CRC16func(arr)
      console.log(this.$t('jym')+":"+crc_result);

      // var base64s = server.buildUserQRcode(mobile_number, crc_result + random_number, utc_number);
      // console.log("server方法:"+base64s);
      var card_number = card;
      card_number = this.getCardNoNineNumber(card_number)
      card_number = parseInt(card_number).toString(16).toUpperCase();

      if(card_number.length > 8){
        Toast.fail(this.$t('khcwqcxsr'));
        return;
      }
      card_number = ('00000000'.substr(0, 8 - card_number.length))+card_number
      console.log(this.$t('kh')+":" + card_number)

      var source = mobile_number + crc_result + random_number + utc_number + card_number;

      console.log(source);
      var source_bytes = new Uint8Array(16);
      for(let i=0;i<16;i++){
        source_bytes[i] = parseInt(source.substr(i * 2,2),16);
      }

      console.log(source_bytes)
      let key = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1];
      let aes_res = AESHQT.encrypt(source_bytes,key);

      console.log(aes_res);

      let aes_bytes = new Uint8Array(aes_res.length/2);
      for (let i = 0; i < aes_res.length/2; i++) {
        aes_bytes[i] = parseInt(aes_res.substr(i * 2, 2), 16);
      }
      console.log(aes_bytes);

      let strDtae = new Buffer(new Uint8Array(aes_bytes))

      let base64_str = strDtae.toString('base64') 

      console.log(this.$t('syym')+": " + base64_str);
      var aes_result =ps+ base64_str;
      console.log(`909`,aes_result)
      this.appSrc = aes_result

    },

    checkHexZero:function(hex){
        var out;
        if(hex.length % 2  == 1)
            out='0'+hex;
        else
            out=hex;
        return out;        
    },

    getPhoneNineNumber:function(phone){
      var spit = phone.split('-');
      var ret;
      var tmp;
      if (spit.length > 0) {
        tmp = spit[spit.length - 1];
      } else {
        tmp = phone;
      }

      if (tmp.length > 9) {
        ret = tmp.substr(tmp.length - 9, 9);
      } else {
        ret = tmp;
      }

      return ret;
    },
    getCardNoNineNumber: function (cardno) {
        var ret;
        if (cardno.length > 9) {
          ret = cardno.substr(cardno.length - 9, 9);
        } else {
          ret = cardno;
        } 
        return ret;
    },
  },
  beforeDestroy() {    //页面关闭时清除定时器  
        clearInterval(this.clearTimeSet);
    },
}
</script>
<style scoped>
.about ul{
  width: 90%;
  margin:0 auto;
  text-align: left;
}
.about ul li{
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
}

.about >>>.van-nav-bar__title{
  margin-left: 40px;
}
.about .qroud >>>.van-dialog__content{
  /* width: 277px; */
  height: 220px;
  padding: 50px 10px 10px 10px;
  text-align: center;
}
.about .qrouds >>>.van-dialog__content{
  /* width: 277px; */
  height: auto;
  padding: 20px 10px 0px 10px;
  text-align: center;
}
.qurys{
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.guanb{

}
</style>